import React from 'react';
import { UserEditForm } from './UserEditForm';

/**
 * Personal Info Page Component
 * Контент-карточка для вкладки "Личная информация" (без внешних page-оберток)
 * Теперь использует универсальный компонент UserEditForm в режиме 'personal'
 */
export function PersonalInfoPage() {
  return <UserEditForm mode="personal" />;
}